import { render, staticRenderFns } from "./TransactionsCloseingBalance.vue?vue&type=template&id=5cd056c0&"
import script from "./TransactionsCloseingBalance.vue?vue&type=script&lang=js&"
export * from "./TransactionsCloseingBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports